import { Box, Button, Flex, Group, ScrollArea, Stack, Text, Tooltip } from '@mantine/core';
import { IconProgressCheck } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { PartialAuthor } from '@feature/utils';

interface AuthorListProps {
  authors: PartialAuthor[];
  onReclaim: (authorId: number) => void;
}

export function ReclaimableAuthorList(props: AuthorListProps) {
  const { authors, onReclaim } = props;
  const { t } = useTranslation();
  return (
    <Stack>
      <Text
        fw="500"
        size="xl"
      >
        {t('authors.form.title')}
      </Text>
      <Text c="dimmed">{t('publications.noClaimableAuthors')}</Text>
      <ScrollArea
        offsetScrollbars
        h={330}
      >
        <Stack>
          {authors.map((author, index) => (
            <Box
              bg="white"
              p="xs"
              style={{ border: '1px solid var(--mantine-color-content-border)', borderRadius: '12px' }}
              key={author.id}
            >
              <Flex
                justify="space-between"
                align="center"
              >
                <Box>
                  <Group
                    mb="1px"
                    gap="xs"
                  >
                    <Text size="sm">#{index + 1}</Text>
                    <Text
                      size="sm"
                      fw={500}
                    >
                      {author.userName}
                    </Text>
                  </Group>
                  <Group gap="3px">
                    <Text
                      size="xs"
                      c="dimmed"
                    >
                      {author.alias}
                    </Text>
                    {author.reclaimed ? (
                      <Tooltip
                        multiline
                        w={300}
                        label={t('authors.claimed.tooltip')}
                      >
                        <IconProgressCheck
                          color="green"
                          size="14px"
                          stroke={2}
                        />
                      </Tooltip>
                    ) : (
                      <Text
                        size="xs"
                        c="dimmed"
                        fs="italic"
                      >
                        ({t('authors.unclaimed')})
                      </Text>
                    )}
                  </Group>
                </Box>
                {!author.reclaimed && (
                  <Button
                    size="xs"
                    onClick={() => onReclaim(author.id)}
                  >
                    Reclaim
                  </Button>
                )}
              </Flex>
            </Box>
          ))}
        </Stack>
      </ScrollArea>
    </Stack>
  );
}
